<div class="hire-search-card mb-3">
  <div class="d-flex justify-content-between w-100 align-items-center">
  <p class="mb-0 font-weight-600 f-14"> Unlock our AI-Powered Analysis!</p>
  <button data-testid="auto-app-hire-talent-insights-button-1" class="filter-criteria-cta">
    Export
  </button>
  </div>
</div>
<div class="d-flex justify-content-between gap-3">
  <div class="hire-search-card mb-3 w-25">
    <div>
      <p class="mb-2 font-weight-600 f-24"> 93K+</p>
      <p class="mb-0 font-weight-400 f-14">Talent count <i class="fa-thin fa-circle-info ml-1"></i></p>
    </div>
  </div>
  <div class="hire-search-card mb-3 w-25">
    <div>
    <p class="mb-2 font-weight-600 f-24"> 15Yrs 2Mths</p>
    <p class="mb-0 font-weight-400 f-14">Median Tenure<i class="fa-light fa-circle-info ml-1"></i></p>
    </div>
  </div>
  <div class="hire-search-card mb-3 w-25">
    <div class="w-50 br-1">
    <p class="mb-2 font-weight-600 f-24">41%</p>
    <p class="mb-0 font-weight-400 f-14"><i class="fa-solid fa-person mr-1"></i> Men</p>
    </div>
     <div class="w-50">
    <p class="mb-2 font-weight-600 f-24">59%</p>
    <p class="mb-0 font-weight-400 f-14"><i class="fa-solid fa-person-dress mr-1"></i> Women</p>
    </div>
  </div>
   <div class="hire-search-card mb-3 w-25">
    <div>
      <p class="mb-2 font-weight-600 f-24"> 402</p>
      <p class="mb-0 font-weight-400 f-14">Changed Jobs (Past 1 yr)</p>
    </div>
  </div>
</div>
